import React from 'react';
import { useDark } from '../../hooks/useDark';
import MoonIcon from '../icons/MoonIcon';
import SunIcon from '../icons/SunIcon';

export default function ThemeSwitcher() {
  const [isDark, toggleTheme] = useDark();
  return (
    <div className="flex gap-x-4">
      <button
        type="button"
        className="text-zinc-500 dark:text-zinc-300 hover:text-zinc-700 dark:hover:text-zinc-100 p-2 rounded-xl focus:outline-none focus-visible:ring-2 focus-visible:ring-cyan-500 dark:focus-visible:ring-cyan-600"
        onClick={toggleTheme}>
        {isDark ? <SunIcon /> : <MoonIcon />}
      </button>
    </div>
  );
}
